import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-termsAndConditions',
  templateUrl: './termsAndConditions.component.html',
  styleUrls: ['./termsAndConditions.component.css']
})
export class TermsAndConditionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
